// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"vs_a bha_b bha_ux"};